var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnelist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#458FDE",
    d: "M43.811,63.455H8.526c-2.292,0-4.151-1.859-4.151-4.152V11.565c0-2.293,1.859-4.151,4.151-4.151h35.285 c2.293,0,4.15,1.858,4.15,4.151v47.738C47.961,61.596,46.104,63.455,43.811,63.455z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M15.791,27.131c-0.266,0-0.531-0.102-0.733-0.304l-3.114-3.114c-0.406-0.404-0.406-1.062,0-1.468 c0.404-0.405,1.062-0.405,1.468,0l2.379,2.38l4.454-4.455c0.406-0.406,1.063-0.406,1.468,0c0.406,0.405,0.406,1.061,0,1.467 l-5.19,5.189C16.322,27.029,16.056,27.131,15.791,27.131z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M38.621,25.094H25.129c-0.572,0-1.038-0.465-1.038-1.039l0,0c0-0.572,0.465-1.039,1.038-1.039h13.492 c0.574,0,1.039,0.465,1.039,1.039l0,0C39.66,24.629,39.195,25.094,38.621,25.094z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M15.791,52.037c-0.266,0-0.531-0.1-0.733-0.303l-3.114-3.113c-0.406-0.408-0.406-1.062,0-1.471 c0.404-0.404,1.062-0.404,1.468,0l2.379,2.383l4.454-4.457c0.406-0.404,1.063-0.404,1.468,0c0.406,0.408,0.406,1.062,0,1.469 l-5.19,5.189C16.322,51.938,16.056,52.037,15.791,52.037z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M38.621,49.998H25.129c-0.572,0-1.038-0.461-1.038-1.035l0,0c0-0.574,0.465-1.039,1.038-1.039h13.492 c0.574,0,1.039,0.465,1.039,1.039l0,0C39.66,49.537,39.195,49.998,38.621,49.998z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M15.791,39.586c-0.266,0-0.531-0.1-0.733-0.305l-3.114-3.115c-0.406-0.404-0.406-1.061,0-1.467 c0.404-0.406,1.062-0.406,1.468,0l2.379,2.379l4.454-4.455c0.406-0.404,1.063-0.404,1.468,0c0.406,0.406,0.406,1.062,0,1.469 l-5.19,5.189C16.322,39.486,16.056,39.586,15.791,39.586z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M38.621,37.547H25.129c-0.572,0-1.038-0.465-1.038-1.037l0,0c0-0.574,0.465-1.039,1.038-1.039h13.492 c0.574,0,1.039,0.465,1.039,1.039l0,0C39.66,37.082,39.195,37.547,38.621,37.547z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#586773",
    d: "M26.204,6.438c-1.005,0-1.755-0.752-1.755-1.756s0.75-1.756,1.755-1.756c1.001,0,1.754,0.752,1.754,1.756 C28.084,5.687,27.208,6.438,26.204,6.438z M34.102,4.934h-3.508c0-2.382-2.006-4.389-4.389-4.389c-2.383,0-4.389,2.006-4.389,4.389 h-3.51c-1.631,0-3.01,1.379-3.01,3.01l0.004,1.973h21.693l-0.004-1.972C37.113,6.313,35.734,4.934,34.102,4.934z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_2_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFD15C",
    points: "40.21,18.634 38.429,25.6 45.395,23.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#334A5E",
    points: "39.292,22.276 38.429,25.6 41.783,24.766  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.487,
    y: 5.895,
    transform: "matrix(-0.7072 -0.707 0.707 -0.7072 73.3852 60.1407)",
    fill: "#FF7058",
    width: 7.319,
    height: 17.958
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40596B",
    d: "M62.907,2.877l-1.781-1.782c-0.934-0.933-2.352-1.044-3.15-0.245l-3.34,3.34l5.178,5.177l3.34-3.341 C63.951,5.229,63.841,3.812,62.907,2.877z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.695,
    y: 6.419,
    transform: "matrix(-0.7073 -0.7069 0.7069 -0.7073 90.8095 52.8959)",
    fill: "#F2F2F2",
    width: 7.32,
    height: 2.459
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A3E261",
    d: "M48.224,54.689c0,5.575-4.539,8.955-10.12,8.914c-0.258-0.001-0.515-0.01-0.769-0.025l0,0 c-5.194-0.339-9.281-3.736-9.207-9.032c0.039-2.741,1.178-5.219,2.994-7.01c0.784-0.771,1.286-1.779,1.434-2.869 c0.006-0.033,0.01-0.061,0.016-0.088c0.534-2.785,2.84-4.88,5.604-4.88h0.028c2.751,0.015,5.045,2.106,5.575,4.88 c0.002,0.012,0.006,0.027,0.008,0.042c0.181,1.125,0.699,2.171,1.505,2.979C47.103,49.416,48.224,51.923,48.224,54.689z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93CC52",
    d: "M38.204,39.699l-0.07,2.131c0,0-0.957,0.726-1.063,2.522c-0.279,4.714-3.956,6.394-3.956,11.153 c0,4.762,1.716,6.628,4.224,8.072h-0.003l0,0c-5.194-0.339-9.281-3.736-9.207-9.032c0.039-2.741,1.178-5.219,2.994-7.01 c0.784-0.771,1.286-1.779,1.434-2.869c0.006-0.033,0.01-0.061,0.016-0.088c0.534-2.785,2.84-4.88,5.604-4.88H38.204L38.204,39.699z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B25719",
    d: "M38.066,41.694c-0.029,0-0.062-0.003-0.092-0.008c-0.285-0.052-0.476-0.324-0.427-0.609l0,0 c0.008-0.047,0.813-4.788-1.165-6.765c-0.205-0.205-0.205-0.538,0-0.743c0.206-0.205,0.539-0.205,0.744,0 c2.363,2.365,1.495,7.474,1.455,7.689C38.538,41.516,38.316,41.694,38.066,41.694z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93CC52",
    d: "M36.957,40.886c0.308-0.002,0.513-0.007,0.697-0.019c0.181-0.01,0.331-0.017,0.479-0.017 c0.151-0.002,0.301,0.006,0.479,0.017c0.186,0.012,0.39,0.014,0.699,0.019c0.002,0.312-0.163,0.565-0.382,0.745 c-0.223,0.177-0.508,0.27-0.797,0.27c-0.286-0.001-0.574-0.093-0.794-0.272C37.12,41.45,36.957,41.197,36.957,40.886z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B25719",
    d: "M39.892,36.479c-1.841,0-2.691-1.243-2.731-1.308c-0.116-0.178-0.069-0.415,0.108-0.533 s0.414-0.071,0.532,0.106c0.043,0.061,0.991,1.405,3.162,0.811c0.205-0.058,0.416,0.063,0.473,0.268 c0.055,0.206-0.064,0.419-0.27,0.474C40.697,36.424,40.272,36.479,39.892,36.479z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FCC6E",
    d: "M46.535,36.951l2.619-2.765l-3.463-1.582c-2.126-0.97-4.628,0.079-5.426,2.273l-0.073,0.199 c-0.206,0.563-0.081,1.195,0.32,1.645l0.142,0.156C42.218,38.612,44.931,38.646,46.535,36.951z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F94848",
    d: "M63.229,51.721c0,3.226-2.101,7.684-4.636,10.12c-1.127,1.083-2.337,1.766-3.49,1.766 c-0.728,0-1.456-0.118-2.083-0.305c-0.856-0.261-1.767-0.261-2.625,0c-0.626,0.187-1.354,0.305-2.083,0.305 c-1.209,0-2.481-0.75-3.652-1.924c-2.464-2.465-4.472-6.806-4.472-9.962c0-4.66,2.785-7.474,5.405-8.152 c1.257-0.326,2.713-0.116,3.89,0.191c1.217,0.315,2.479,0.367,3.711,0.156c0.25-0.041,0.495-0.093,0.739-0.156 c1.177-0.308,2.632-0.518,3.891-0.191C60.441,44.247,63.229,47.061,63.229,51.721z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E23D3D",
    d: "M58.593,61.841c-3.113,0.551-5.512,0.398-7.318-0.039c-2.952-0.715-5.146-3.203-5.512-6.218 c-0.914-7.547,4.018-9.745,4.018-9.745c1.443,0.658,3.07,0.308,3.07,0.308c-1.038-1.038,0.343-2.23,0.343-2.23 c-1.231,0.211-2.494,0.159-3.711-0.156c-1.177-0.308-2.633-0.518-3.89-0.191c-2.62,0.679-5.405,3.492-5.405,8.152 c0,4.658,4.372,11.886,8.124,11.886c0.729,0,1.457-0.118,2.083-0.305c0.858-0.261,1.769-0.261,2.625,0 c0.627,0.187,1.355,0.305,2.083,0.305C56.256,63.606,57.466,62.924,58.593,61.841L58.593,61.841z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7F492",
    d: "M64.358,37.08c0,0-0.647,4.51-4.058,5.821c-3.256,1.256-6.16-2.139-7.35-1.869 c-0.056,0.01-0.106,0.031-0.15,0.058c-0.003,0-0.003,0-0.003,0v-0.001c0.039-0.122,1.347-4.013,4.701-4.268 C60.907,36.562,62.76,38.113,64.358,37.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3E261",
    d: "M64.358,37.08c0,0-2.072,2.522-4.983,2.522c-2.56,0-5.704,1.151-6.424,1.43 c-0.087,0.032-0.139,0.054-0.15,0.058c-0.003,0-0.003,0-0.003,0v-0.001c0.039-0.122,1.347-4.013,4.701-4.268 C60.907,36.562,62.76,38.113,64.358,37.08z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9951 0.0989 -0.0989 -0.9951 123.6157 93.3736)",
    fill: "#FC8181",
    cx: 59.494,
    cy: 49.75,
    rx: 1.506,
    ry: 2.327
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E23D3D",
    d: "M54.119,45.509c0,0.529-0.831,0.971-1.936,1.07c-0.154,0.015-0.312,0.021-0.478,0.021 c-0.17,0-0.334-0.006-0.494-0.021c-1.094-0.105-1.916-0.542-1.916-1.069H54.119z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B25719",
    d: "M53.55,41.033l-1.771,2.688c0.133,0.545,0.249,1.146,0.322,1.787c0.041,0.345,0.069,0.703,0.083,1.07 c-0.154,0.015-0.312,0.021-0.478,0.021c-0.17,0-0.334-0.006-0.494-0.021c-0.014-0.368-0.047-0.725-0.089-1.069 c-0.317-2.513-1.286-4.362-1.298-4.384c-0.126-0.238-0.036-0.53,0.201-0.655c0.236-0.127,0.529-0.038,0.656,0.198 c0.026,0.055,0.386,0.737,0.743,1.822l1.312-1.992c0.146-0.222,0.449-0.282,0.672-0.138C53.635,40.51,53.695,40.809,53.55,41.033z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnelist);
export default __webpack_public_path__ + "static/media/onelist.2b9374047a05fc5f9362eae73175063d.svg";
export { ForwardRef as ReactComponent };